import { IApiClient } from "../api-client";
import { EnvType } from "../services";
import { CatalogReportingResponse } from "../Types/catalog-reporting-response";
import { DbAssetObjectInfos } from "../Types/db-asset-object-infos";
import { GenericResponseStd } from "../Types/generic-response-std";
import { GetDetailedTmdbTitleRequest } from "../Types/get-detailed-tmdb-title-request";
import { GetDetailedTmdbTitleResponse } from "../Types/get-detailed-tmdb-title-response";
import { GetMetadataFieldsResponse } from "../Types/get-metadata-fields-response";
import { GetSearchTmdbTitlesResponse } from "../Types/get-search-tmdb-titles-response";
import { ImportArtworksResponse } from "../Types/import-artworks-response";
import { SearchTitleRequest } from "../Types/search-title-request";
import { SearchTitleResponse } from "../Types/search-title-response";
import { TitleType } from "../Types/title-type";

interface ITitleApiClient {
  CreateTitle(request: DbAssetObjectInfos): Promise<GenericResponseStd>;
  UpdateTitle(request: DbAssetObjectInfos): Promise<GenericResponseStd>;
  GetMetadataFields(): Promise<GetMetadataFieldsResponse>;
  SearchTmdbMovies(name: string, type: TitleType): Promise<GetSearchTmdbTitlesResponse>;
  GetDetailedTmdbTitle(request: GetDetailedTmdbTitleRequest): Promise<GetDetailedTmdbTitleResponse>;
  ConnectSearchTitle(request: SearchTitleRequest): Promise<SearchTitleResponse>;
  ConnectLinkTitle(titleId: number, connectId: number): Promise<GenericResponseStd>;
  ConnectImportMetadata(titleId: number): Promise<GenericResponseStd>;
  ConnectImportArtworks(titleId: number): Promise<ImportArtworksResponse>;
  SyncTitleWithSpock(titleId: number): Promise<GenericResponseStd>;
}

export default class TitleApiClient implements ITitleApiClient {
  readonly servicePort = 9508;
  readonly serviceBaseUrl = "title-service/api";

  titleApiClient: IApiClient;

  constructor(titleApiClient: IApiClient, envType: EnvType) {
    this.titleApiClient = titleApiClient;
    if (envType === "local") this.titleApiClient.client.defaults.baseURL += `${this.servicePort}/`;
  }
  async CreateTitle(request: DbAssetObjectInfos): Promise<GenericResponseStd> {
    return await this.titleApiClient.post(`${this.serviceBaseUrl}/create`, request);
  }
  async UpdateTitle(request: DbAssetObjectInfos): Promise<GenericResponseStd> {
    return await this.titleApiClient.post(`${this.serviceBaseUrl}/update`, request);
  }
  async GetMetadataFields(): Promise<GetMetadataFieldsResponse> {
    return await this.titleApiClient.get(`${this.serviceBaseUrl}/fields`);
  }
  async SearchTmdbMovies(name: string, type: TitleType): Promise<GetSearchTmdbTitlesResponse> {
    return await this.titleApiClient.get(`${this.serviceBaseUrl}/tmdb/search/${name}/${type}`);
  }
  async GetDetailedTmdbTitle(request: GetDetailedTmdbTitleRequest): Promise<GetDetailedTmdbTitleResponse> {
    return await this.titleApiClient.post(`${this.serviceBaseUrl}/tmdb/detailed`, request);
  }
  async ConnectSearchTitle(request: SearchTitleRequest): Promise<SearchTitleResponse> {
    return await this.titleApiClient.post(`${this.serviceBaseUrl}/connect/search`, request);
  }
  async ConnectLinkTitle(titleId: number, connectId: number): Promise<GenericResponseStd> {
    return await this.titleApiClient.put(`${this.serviceBaseUrl}/connect/link/${titleId}/${connectId}`);
  }
  async ConnectImportMetadata(titleId: number): Promise<GenericResponseStd> {
    return await this.titleApiClient.put(`${this.serviceBaseUrl}/connect/import/${titleId}`);
  }
  async ConnectImportArtworks(titleId: number): Promise<ImportArtworksResponse> {
    return await this.titleApiClient.put(`${this.serviceBaseUrl}/connect/import/${titleId}/artworks`);
  }
  async SyncTitleWithSpock(titleId: number): Promise<GenericResponseStd> {
    return await this.titleApiClient.post(`${this.serviceBaseUrl}/spock-sync/${titleId}`);
  }
  async GetCatalogReporting(): Promise<CatalogReportingResponse> {
    return await this.titleApiClient.get(`${this.serviceBaseUrl}/reporting/catalog`);
  }
  async GetCatalogReportingByTitle(titleId: number): Promise<CatalogReportingResponse> {
    return await this.titleApiClient.get(`${this.serviceBaseUrl}/reporting/catalog/${titleId}`);
  }
  async DownloadCatalogReportAsCSV(): Promise<GenericResponseStd> {
    return await this.titleApiClient.get(`${this.serviceBaseUrl}/reporting/catalog/csv`);
  }

  //------Utils------
  GetApiUrl(): string {
    return this.titleApiClient.client.defaults.baseURL + this.serviceBaseUrl;
  }
}
